import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { find as _find } from 'lodash';

import { chatModule } from '@chedri/base';

class TimelineHeader extends React.Component {
  render() {
    const {
      intl: { messages },
      communication,
      creatorId,
      creatorName,
      creatorAvatar,
      title,
      onOpenConverstation,
    } = this.props;

    let chatUser = null;
    let isOnline = false;
    if (creatorId && communication.socket.isConnected) {
      chatUser = _find(communication.contact.list, ['id', creatorId]);
      isOnline = !!(chatUser && (chatUser.is_online || chatUser.is_mobile_online));
    }

    const tooltip = isOnline ? (
      <Tooltip>
        {messages.user_is_online}
        <br />
        {messages.click_to_start_chat}
      </Tooltip>
    ) : (
      <Tooltip>
        {messages.user_is_offline}
        <br />
        {messages.click_to_view_chat_history}
      </Tooltip>
    );

    return (
      <div class="card-header clearfix">
        <div class="user-pic">
          {creatorAvatar ? (
            <img alt={creatorName} width="33" height="33" src={creatorAvatar} />
          ) : (
            <i class="fal fa-fw fa-user-circle text-master-light" style={{ fontSize: '33px' }} title={creatorName} />
          )}
        </div>
        <h5>
          {chatUser ? (
            <OverlayTrigger placement="top" overlay={tooltip}>
              <span onClick={() => onOpenConverstation(chatUser)} class="inline cursor lh-23">
                <i class={'fa-fw fs-10 ' + (isOnline ? 'fas fa-circle text-success' : 'far fa-circle text-danger')} />{' '}
                <span class="text-master">{creatorName || 'Chedri'}</span>
              </span>
            </OverlayTrigger>
          ) : (
            <span class="inline lh-23">
              <i class={'fa-fw fs-10 ' + (isOnline ? 'fas fa-circle text-success' : 'far fa-circle text-danger')} />{' '}
              <span class="text-master">{creatorName || 'Chedri'}</span>
            </span>
          )}
        </h5>
        <h6>{title}</h6>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    communication: state.communication,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    onOpenConverstation: username => {
      dispatch(chatModule.actions.openChat(username, false, undefined, undefined));
    },
  };
};

export default injectIntl(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(TimelineHeader)
);
